import PollCreation from '@/shared-components/forms/add-board-content/board-text-body/add-element/add-polls/PollCreation';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';

import { handleGenericEdit,handleGenericSubmit } from '../../utils';

import PollDisplay from './PollDisplay';

export default function PollManager({
  formState,
  setFormState,
  editableRef,
  isPollModalOpen,
  setIsPollModalOpen,
  handlePollEdit,
  pollToEdit,
  setPollToEdit,
  textEditorSelector,
  removePollFromDom,
}) {
  const handleClose = () => {
    setIsPollModalOpen(false);
    setPollToEdit(null);
  };

  const handleDelete = () => {
    if (!pollToEdit) return;
    removePollFromDom(pollToEdit.pollId);
    handleClose();
  };

  // 4) Create a new poll
  const handlePollSubmit = (data) => {
    const newId   = (formState.post_polls?.length || 0) + 1; 
    const newPoll = { pollId: newId, question: data.question, options: data.options };

    const polls = [...formState.post_polls, newPoll];

    setFormState(prev => ({
      ...prev,
      post_polls: polls,
    }));

    const containerId = `poll-${newId}`;

    handleGenericSubmit(textEditorSelector, editableRef, containerId,
      <PollDisplay
        pollId={newId}
        title={data.question}
        options={data.options}
        initialHasVoted={false}
        initialUserAnswer={null}
        previewMode={false}
        onVote={undefined}
        onEditClick={() => handlePollEdit(newId, polls)}
      />);

    setIsPollModalOpen(false);
  };

  // 5) Update an existing poll
  const handlePollUpdate = (updated) => {
    if (!pollToEdit) return;
    const id = pollToEdit.pollId;

    setFormState(prev => {

      const polls = prev.post_polls.map(poll => ({
        ...poll,
        ...updated,
      }));

      const containerId = `poll-${id}`;

      handleGenericEdit(containerId, 
        <PollDisplay
          pollId={id}
          title={updated.question}
          options={updated.options}
          initialHasVoted={false}
          initialUserAnswer={null}
          previewMode={false}
          onVote={undefined}
          onEditClick={() => handlePollEdit(id, polls)}
          hasAnybodyAnswered={updated.hasAnybodyAnswered}
        />
      );

      return {
        ...prev,
        post_polls: polls,
      };
    });

    setPollToEdit(null);
    setIsPollModalOpen(false);
  };

  // 7) Only render the creation/edit modal
  return (
    <>
      {isPollModalOpen && (
        <GenericPopup
          className="poll-quiz-creation-popup remove-scrollbar"
          open={isPollModalOpen}
          opacity
          onBackgroundClick={handleClose}
        >
          {/*
              PollCreation expects options to be simple strings.
              If this poll has already gathered votes, its options
              look like { text, votes }.  Strip them back to strings.
           */}
          <PollCreation
            initialPollData={
              pollToEdit
                ? {
                  ...pollToEdit,
                  options: pollToEdit.options.map(o =>
                    typeof o === "string" ? o : o.text
                  )
                }
                : null
            }
            onSubmit={pollToEdit ? handlePollUpdate : handlePollSubmit}
            onClose={handleClose}
            onDelete={pollToEdit ? handleDelete : undefined}
          />
        </GenericPopup>
      )}
    </>
  );
}
